// Small popup panels and menus.
import { useState } from "react";
import { StyleSheet, View } from "react-native";
import { colorSurfacePrimary, colorTextPrimary } from "./color";
import { UtilityText } from "./text";
import { HorizBox, Pad } from "./basics";
import { PopupBase } from "platform-specific/popup";
import { ChevronDown, ChevronUp } from '@carbon/icons-react';
import { undefA, undefS, undefTL } from "util/stdtypes";
import { TextButton } from "./button";


export function PopupPanel({children, popupContent, alignRight=false, testID=undefS, setHover=undefA}) {
    const s = PopupPanelStyle;
    const [shown, setShown] = useState(false);
    return <View style={{alignSelf: 'flex-start'}}>
        <PopupBase testID={testID} popupContent={popupContent} alignRight={alignRight} setHover={setHover} setShown={setShown}>
            <View style={s.button}>
                {children}
                <Pad size={8} />
                {shown ? <ChevronUp size={16} color={colorTextPrimary}/> : <ChevronDown size={16} color={colorTextPrimary}/>}
            </View>
        </PopupBase>
    </View>
}

const PopupPanelStyle = StyleSheet.create({
    button: {
        flexDirection: 'row',
        alignSelf: 'flex-start',
        alignItems: 'center',
    }
})

// Need to have this here rather than in platform-specific, because it's hard for
// other components to import from platform-specific
export function Popup(params) {
    return <PopupBase {...params}/>
}


export function DropDownSelector({testID=undefS, label = undefTL, text=undefS, options=undefA, value=undefS, onChange=(k: string)=>{}}) {
    const [hover, setHover] = useState(false);
    const selectedOption = options.find(o => o.key == value) || options[0];
    function popupContent({onClose}) {
        return <View style={{backgroundColor: colorSurfacePrimary}}>
            {options.map((o, i) => <View key={i}>
                {i != 0 && <Pad size={20} />}
                <TextButton label={o.label} text={o.text} type='small' onPress={() => {onChange(o.key); onClose()}} />
            </View>)}
        </View>
    }
    return <PopupPanel testID={testID} popupContent={popupContent} alignRight setHover={setHover}>
        <HorizBox>
            <UtilityText label={label} text={text} type='small' weight='medium' />
            {(label || text) && <UtilityText text=': ' type='small' weight='medium' /> /** Do not render a lone colon if no label provided*/} 
            <UtilityText label={selectedOption.label} type='small' underline={hover} weight='medium' />
        </HorizBox>
    </PopupPanel>
}
